import { useEvents } from "@/hooks/useEvents";
import { LeagueGroups } from "@/components/LeagueGroups";

export default function Live() {
  const { data, dataUpdatedAt } = useEvents({ state: "in" }, 15000);
  return (
    <div className="space-y-5">
      <div className="flex flex-wrap items-end justify-between gap-2">
        <div>
          <h1 className="flex items-center gap-3 font-display text-4xl font-black uppercase tracking-tight sm:text-5xl">
            <span className="live-dot h-3 w-3 rounded-full bg-[#EF4444]" /> Live In-Play
          </h1>
          <p className="mt-1 text-sm text-slate-400">Scores and odds refresh automatically every 15 seconds.</p>
        </div>
        {dataUpdatedAt > 0 && (
          <span data-testid="live-updated-at" className="text-xs text-slate-500">
            Updated {new Date(dataUpdatedAt).toLocaleTimeString()}
          </span>
        )}
      </div>
      <LeagueGroups events={data} empty="No matches are in-play right now. Check back soon or browse upcoming fixtures." />
    </div>
  );
}
